export default "__VITE_ASSET__DewE7Nib__"